import {Table, DataTable} from '@primer/react/experimental'
import type {ConvertToRulesetPreview} from '../types'
import {Preview} from './preview'
import {BranchName, Checkbox} from '@primer/react'
import {useUpdatePreviews} from '../contexts/UpdatePreviewsContext'

export type PreviewsTableProps = {
  previews: ConvertToRulesetPreview[]
}

export function PreviewsTable({previews}: PreviewsTableProps) {
  const {togglePreview} = useUpdatePreviews()

  return (
    <>
      <h2 className="sr-only" id="previews-table">
        Ruleset previews
      </h2>
      <Table.Container>
        <DataTable
          aria-labelledby="previews-table"
          data={previews}
          columns={[
            {
              header: 'Rule',
              field: 'targetedBranches',
              renderCell(preview) {
                return (
                  <span className="d-flex flex-row flex-items-center gap-1">
                    <Checkbox checked={preview.isEnabled} onChange={() => togglePreview({id: preview.id})} />{' '}
                    <BranchName>{preview.targetedBranches}</BranchName>
                  </span>
                )
              },
            },
            {
              header: 'Ruleset name',
              field: 'rulesets',
              renderCell(preview) {
                return <Preview preview={preview} />
              },
            },
          ]}
        />
      </Table.Container>
    </>
  )
}
